import config from "../../../config";

import { AppDispatch } from "../../../store";
import { siteContextRequest } from "../../../redux/siteContextRequest";

type FlightPlan = {
  fixedWingKml: string;
  quadcopterKml: string;
};

export const fetchFlightPlan = (customerId: string, siteId: string) => async (
  dispatch: AppDispatch,
): Promise<FlightPlan> => {
  const { data } = await dispatch(
    siteContextRequest(customerId, siteId, {
      method: "GET",
      url: `${config.endpoints.backofficeWebService}/api/kml/${customerId}/${siteId}`,
    }),
  );
  return {
    fixedWingKml: data["fixed-wing"],
    quadcopterKml: data["quadcopter"],
  };
};
